// This is a custom script that re-initializes Giftship's datepicker with a new format 2020-01-01

var GsLoaded = function() {
  


  Gs.datepicker.date_format = "Y/m/d";
  Gs.datepicker.required    = 0;
  
  Gs.$("#gsDeliveryDate").removeAttr('required')
  
  
  
  
  gs__settings.options.datepicker.date_format = "Y/m/d";
                  
  Gs._initDatepicker();
  

};